<template>
  <div class="c-exercise" :id="getID()" >
    <template v-if="exercise">
      <div class="c-exercise__status c-exercise__stripped-block">
        <div class="c-exercise-pass__exercise js-exercise" :class="getExerciseClass()">
        </div>
      </div>
      <!--<div class="c-exercise__status c-exercise__participant-name">
        <div class="c-exercise__status-label name">{{$t(getStatus())}}</div>
        <div class="c-session-block__meta-info">
          {{ $t('exercise.type.' + exercise.exerciseTypeId) }}
        </div>
      </div>-->

      <div class="c-exercise__participant c-exercise__stripped-block" style="width: 180px;">
        <div class="c-exercise__participant-info">
          <component
            :is="'participant-'+ participation.participantType"
            :participation="participation"
            class="c-exercise__participant-name"
            />
        </div>
      </div>
      <div class="c-exercise__participant c-exercise__stripped-block" style="width: 162px;">
        <div class="c-exercise__participant-info">
          <div class="c-exercise__participant-name">
            <div class="name">{{getCategory().name}}</div>
            <div v-if="mixed">{{ $t(`exercise.type.${exercise.exerciseTypeId}`)}}</div>
          </div>
        </div>
      </div>

      <div class="c-exercise__stripped-block c-exercise__results">
        <strong>{{ getExerciseScore() }}</strong>
      </div>
    </template>

    <template v-else >
      <div>Missing exercise</div>
    </template>
  </div>
</template>

<script>
  import find from 'lodash/find'
  import range from 'lodash/range'
  import numeral from 'numeral'

  import blockLib from "@/lib/block"
  import exerciseLib from "@/lib/exercise"
  import participantLib from 'client/lib/participant'
  import options from '@/lib/options'

  export default {
    name: "blockExercise",
    components: {
      'participant-clubMember': () => import('client/components/models/participantClubMember.vue'),
      'participant-group': () => import('client/components/models/participantGroup.vue'),
      'exerciseResult': () => import('client/components/models/exerciseResult.vue'),
    },
    props: ['blockParticipation', 'exerciseTypeId', 'pass', 'panelId', 'mixed'],
    colors: options.dashboard.colors,
    data: function() {
      return {
        passes: 1,
        status: 'present',
      }
    },
    computed: {
      exercise: function() {
        if (this.blockParticipation.filler) {
          return null
        }

        const exerciseTypeId =
          blockLib.getBlockParticipationExerciseType(this.blockParticipation, this.exerciseTypeId, this.panel)

        return exerciseLib.getExercise(
          this.blockParticipation.participationId, this.panel.roundIndex, exerciseTypeId)
      },
      panel: function() {
        return find(this.$store.state.panels.items, i => i.id === this.panelId )
      },
      categories: function() {
        return this.$store.state.categories.items
      },
      participation: function() {
        return participantLib.getParticipation(this.blockParticipation.participationId)
      },
      clubs: function() {
        return this.$store.state.clubs.items
      },
      members: function() {
        return this.$store.state.members.items
      },
      settings: function() {
        return find(this.$store.state.panels.configurations, i => i.panelId === this.panelId)
      },
    },
    created: function() {
      this.setStatus()
      if (this.exercise && this.exercise.config && this.exercise.config.passes) {
        this.passes = this.exercise.config.passes;
      }
    },
    watch: {
      participation: function() {
        this.setStatus();
      }
    },
    methods: {
      setStatus: function() {
        if (this.blockParticipation.filler) {
          this.status = 'filler'
          return
        }

        const partRound = find(this.participation.rounds, item => item.roundIndex === this.panel.roundIndex)
        this.status = partRound.status
      },
      getID: function() {
        let id = 'ex-' + this.exercise.id;
        if (this.settings.splitPasses) {
          id += '-' + this.pass;
        }
        return id;
      },
      getCategory: function() {
        return find(this.categories, i => i.id === this.participation.categoryId)
      },
      getStatus: function() {

        if (this.status !== 'present') {
          return this.status
        }

        if (this.exercise) {
          return this.exercise.status
        }

        return 'exercise.status.missing'
      },
      getExerciseClass: function() {
        return this.$options.colors[this.getStatus()].class
      },
      getPasses: function() {
        if (parseInt(this.pass) === 0) {
          return range(this.passes);
        }
        else {

          return [this.pass-1];
        }
      },
      getExerciseLabel: function() {
        return participantLib.getExerciseLabel(this.participation, this.exercise.roundIndex, this.exercise.exerciseTypeId)
      },
      getExerciseScore: function() {
        if (this.exercise?.summary) {
          return numeral(this.exercise.summary.total).format('0.000')
        }
        return ''
      },
    }
  };
</script>

<style scoped>
.c-exercise {
  display: flex;
  flex-direction: row;
}

.c-exercise .c-exercise__stripped-block {
  padding: 6px;
}

.c-exercise__status {
  width: 36px;
  flex-grow: 0;
  margin: 0 0 0 0;
  padding: 12px;
  background: inherit;
}

.c-exercise__participant {
  flex-grow: 1;
}

.c-exercise__participant-name {
  font-size: 14px;
  line-height: 1.42857;
  margin: 0;
}

.c-exercise__results {
  flex-grow: 0;
  justify-content: flex-end;
  padding-right: 10px;
  width: 72px;
}

</style>
